import { render, staticRenderFns } from "./DateFilterItem.vue?vue&type=template&id=1f95e3e2&scoped=true&"
import script from "./DateFilterItem.vue?vue&type=script&lang=js&"
export * from "./DateFilterItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f95e3e2",
  null
  
)

export default component.exports